export default __webpack_public_path__ + "static/media/user-icon-green.23cc8929.svg";